const IconGoogle = () => {
  return (
    <img
      src="/images/google.png"
      alt="Google"
      style={{ width: "24px", height: "24px", objectFit: "contain" }}
    />
  );
};

export default IconGoogle;
